import { Alert, AlertTitle, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * A confirmed action whose result the server could not establish (#2104).
 *
 * Deliberately offers no retry, and deliberately is not a green tick: the plan
 * is already spent, a later confirm replays the same `unknown`, and a same-key
 * re-POST is precisely what would create a second record.
 *
 * The portal never sees `409 IDEMPOTENCY_OUTCOME_UNKNOWN` itself — the
 * orchestrator consumes that 409 and reports `outcome: 'unknown'` on an
 * ordinary `action_confirmed` turn. This notice reads that field.
 */
export function UncertainOutcomeNotice() {
  const { t } = useTranslation('assistant');

  return (
    <Box sx={{ mb: 1.5, ml: 4.5 }}>
      <Alert severity="warning" variant="outlined" sx={{ maxWidth: '85%' }}>
        <AlertTitle>{t('confirmation.uncertain.title')}</AlertTitle>
        {t('confirmation.uncertain.body')}
      </Alert>
    </Box>
  );
}
